// export const NTECH_API = 'http://localhost:3000';
export const NTECH_API = 'http://ntechsolucoes.com.br:64852';
export const NTECH_API_2 = 'http://ntechsolucoes.com.br:64853';



// WEBPACK FOOTER //
// ./src/app/app.api.ts